import { EventBuilder } from './EventBuilder';
import Core from '../Core/Core';

export interface IParamsNewSaved {
    consecutiveWinCount: number;
    consecutiveWinHighest: number;
    lastLevelAttempted: number;
    lastLevelWon: number;
    coinsSpent: number; // will start recording from when deltaDna version is live
    coinPurchasesMade: number;
    adsWatchedRewarded: number;
    adsWatchedInterstitial: number;
    livesBoughtWithCoins: number;
    numSocialShares: number;
    numSocialChallengesSent: number; // not implemented yet so will be 0
    adsLastTimeShownRewarded: number;
    adsLastTimeShown: number;
    numFriendsInvited: number;
}

// this will be populated by player saved data on game start
// and then updated by middleware during play
const DefaultNewSavedParams: IParamsNewSaved = {
    consecutiveWinCount: 0, //.
    consecutiveWinHighest: 0, //.
    lastLevelAttempted: 0, //.
    lastLevelWon: 0, //.
    coinsSpent: 0, //. (//. means done) // will start recording from when deltaDna version is live
    coinPurchasesMade: 0, //. incrementing and saving every time we deduct coins (only lose when we buy something)
    adsWatchedRewarded: 0, //.
    adsWatchedInterstitial: 0, //.
    livesBoughtWithCoins: 0, //.
    numSocialShares: 0, //.
    numSocialChallengesSent: 0, //. not implemented yet so will be 0
    adsLastTimeShownRewarded: 0, //.
    adsLastTimeShown: 0, //.
    numFriendsInvited: 0, //.
};

export class SavedParamBuilder extends EventBuilder {
    public sessionStart: number;
    private storedData: IParamsNewSaved;

    constructor() {
        super();

        // init stored data

        this.sessionStart = Date.now();
        this.storedData = { ...DefaultNewSavedParams };
    }

    public async initSavedParams() {
        await this.restoreParams();
    }

    public setParamsFromGame(data: Partial<IParamsNewSaved>): void {
        const oldData = this.storedData;
        this.storedData = Object.assign(oldData, data);
        this.saveParams();
    }

    public getCurrentSavedData<T>(): IParamsNewSaved {
        return this.storedData;
    }

    public getParams<T>(): IParamsNewSaved {
        return {
            ...this.storedData,
        };
    }

    public setParams(keys: Map<string, number>): void {
        keys.forEach((value, key) => {
            if (this.storedData.hasOwnProperty(key)) {
                Core.sdk.data.saveData(key, value).catch(err => {
                    throw err;
                });
                const stored: any = this.storedData;
                stored[key] = value;
            }
        });
    }

    private saveParams() {
        Object.keys(this.storedData).forEach(key => {
            const stored: any = this.storedData;
            Core.sdk.data.saveData(key, stored[key]).catch(err => {
                throw err;
            });
        });
    }

    private async restoreParams() {
        const initialData = DefaultNewSavedParams;
        for (let key in initialData) {
            await Core.sdk.data
                .getData(key)
                .then(res => {
                    if (res) {
                        // @ts-ignore
                        this.storedData[key] = res;
                    }
                })
                // @ts-ignore
                .catch(err => {});
        }

        return;
    }
}
